import { PageMap } from '@wix/wixstores-client-core/dist/es/src/constants';
var CustomUrlApi = /** @class */ (function () {
    function CustomUrlApi(buildUrl) {
        this.buildUrl = buildUrl;
    }
    CustomUrlApi.prototype.buildProductPageUrl = function (urlSegments) {
        return this.buildUrl(PageMap.PRODUCT, urlSegments);
    };
    return CustomUrlApi;
}());
export { CustomUrlApi };
//# sourceMappingURL=CustomUrlApi.js.map